import { __assign } from "tslib";
import React from 'react';
import useClientData from '../hooks/useClientData';
var withClientData = function (WrappedComponent, props) {
    return function (pageProps) {
        var WithClientDataComp = function () {
            var data = useClientData(props).data;
            var componentProps = __assign(__assign({}, pageProps), { data: data });
            return React.createElement(WrappedComponent, __assign({}, componentProps));
        };
        WithClientDataComp.displayName = "WithClientData".concat(WrappedComponent.displayName || WrappedComponent.name || 'Component');
        return WithClientDataComp();
    };
};
export default withClientData;
//# sourceMappingURL=withClientData.js.map